// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-button {
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background: transparent;
  padding: 8px;
  font-family: inherit;
  color: inherit;
  min-width: fit-content;
  min-height: fit-content;
}

.icon-button:hover {
  background-color: var(--color-light-gray);
}

.icon-button:active {
  background-color: var(--color-gray);
}

/* Disabled state */
.icon-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.icon-button.disabled:hover {
  background-color: transparent;
}

/* Focus states for accessibility */
.icon-button:focus {
  outline: 2px solid var(--color-primary-green);
  outline-offset: 2px;
}

.icon-button:focus:not(:focus-visible) {
  outline: none;
} `, "",{"version":3,"sources":["webpack://./src/components/Button/IconButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".icon-button {\n  border: none;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  background: transparent;\n  padding: 8px;\n  font-family: inherit;\n  color: inherit;\n  min-width: fit-content;\n  min-height: fit-content;\n}\n\n.icon-button:hover {\n  background-color: var(--color-light-gray);\n}\n\n.icon-button:active {\n  background-color: var(--color-gray);\n}\n\n/* Disabled state */\n.icon-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.icon-button.disabled:hover {\n  background-color: transparent;\n}\n\n/* Focus states for accessibility */\n.icon-button:focus {\n  outline: 2px solid var(--color-primary-green);\n  outline-offset: 2px;\n}\n\n.icon-button:focus:not(:focus-visible) {\n  outline: none;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
